export default function showInfo(){
    console.log("%c%s","font-size: 14px; margin: 5px","Frontend Version: 2.1.0@20221221-GMT+8-11:15:30");
    
    console.log("%c%s",
        "color: #fff; background: #42b883; padding: 5px 10px; border-radius: 4px; font-size: 14px;",
        "Built with Vue 3 framework!");
}
